var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Formatting_Outline_Palette",
    "data-name": "Icon/Formatting/Outline/Palette",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,10a10,10,0,1,1,20,0,10.121,10.121,0,0,1-.247,2.223,10.278,10.278,0,0,1-.355,1.2l-.072.171a2.436,2.436,0,0,1-2.183,1.39l-2.511.01a1,1,0,0,0-.976.8l-.462,2.27a2.363,2.363,0,0,1-2.057,1.872l-.363.034c-.257.02-.517.03-.775.03A10.011,10.011,0,0,1,0,10Zm2,0a8.01,8.01,0,0,0,8,8c.2,0,.411-.008.6-.022l.324-.031a.353.353,0,0,0,.307-.282L11.7,15.4a3.013,3.013,0,0,1,2.929-2.4l2.51-.009a.417.417,0,0,0,.363-.2l.035-.082A8,8,0,1,0,2,10Zm4,4a1,1,0,1,1,1,1A1,1,0,0,1,6,14ZM4,10a1,1,0,1,1,1,1A1,1,0,0,1,4,10Zm9-3a1,1,0,1,1,1,1A1,1,0,0,1,13,7ZM5,6A1,1,0,1,1,6,7,1,1,0,0,1,5,6ZM9,5a1,1,0,1,1,1,1A1,1,0,0,1,9,5Z",
    fill: "#212121"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.ae730afd.svg";
export { ForwardRef as ReactComponent };